export default __webpack_public_path__ + "static/media/contactus.2b302f1f.png";